import React from "react";
import Header from "./Header";

const CopyrightPolicy = () => {
  return (
    <div className="legal-container">
      <Header/>
      <div>
        <h1>Copyright & Intellectual Property Policy</h1>
        <p><strong>Last Updated:</strong> 12/1/2026</p>

        <h2>1. Platform Ownership</h2>
        <p>
          All platform-related content including branding, design, code, and UI
          elements are the intellectual property of Nkechukwu's Vision LTD unless
          otherwise stated.
        </p>

        <h2>2. Third-Party Content</h2>
        <p>
          Images, videos, artworks, and jewelry designs may belong to independent
          artists or jewellers. NV does not claim ownership of such works.
        </p>

        <h2>3. Prohibited Use</h2>
        <ul>
          <li>Unauthorized copying or redistribution</li>
          <li>Commercial use without permission</li>
          <li>Misrepresentation of ownership</li>
        </ul>

        <h2>4. Copyright Takedown Requests</h2>
        <p>
          If you believe your copyrighted work appears on the Platform without
          authorization, please email
          <strong> nkechukwu@nv.luxury</strong> with proof of ownership and the
          location of the content.
        </p>

        <h2>5. Repeat Infringement</h2>
        <p>
          NV reserves the right to suspend or terminate accounts that repeatedly
          violate intellectual property rights.
        </p>

        <h2>6. Contact</h2>
        <p>Email: nkechukwu@nv.luxury</p>
      </div>
      
    </div>
  );
};

export default CopyrightPolicy;
